// @ts-nocheck
'use client'

import React, { memo } from 'react'
import Script from 'next/script'

import { isClient } from '@rewardops/utils'

interface AirCanadaHeadersProps {
  analyticScriptsUrls: string[]
}

// Ref: https://aircanada.atlassian.net/wiki/spaces/DA/pages/3639836940/WEB-Apple+eStore-00+Main+Header+Implementation
const AirCanadaHeaders = memo(
  ({ analyticScriptsUrls }: AirCanadaHeadersProps) => {
    return (
      <Script
        strategy="afterInteractive"
        onLoad={() => {
          {
            /* <!-- Script 1. Declare digitalDataAC object and functions. --> <!-- Copy as it is.--> */
          }
          if (isClient()) {
            window.digitalDataAC = window.digitalDataAC || { events: [] }
          }

          {
            /* <!-- Script 2. digitalDataAC objects. --> */
            /* Needs tenant and session providers. Done later with <AirCanadaMainHeaderEvent /> */
          }

          {
            /* <!-- Script 3. Adobe Target prehiding snippet for asynchronous deployment. --> <!-- Copy as it is.--> */
          }
          ;(function (g, b, d, f) {
            ;(function (a, c, d) {
              if (a) {
                var e = b.createElement('style')
                e.id = c
                e.innerHTML = d
                a.appendChild(e)
              }
            })(b.getElementsByTagName('head')[0], 'at-body-style', d)
            setTimeout(function () {
              var a = b.getElementsByTagName('head')[0]
              if (a) {
                var c = b.getElementById('at-body-style')
                c && a.removeChild(c)
              }
            }, f)
          })(window, document, 'body {opacity: 0 !important}', 3e3)

          {
            /* <!-- Script 4. Adobe Tag Manager JavaScript ID.-->
            <!-- Use 'Container Code IDs' from table below.--> 
            
            Moved to afterwards. Cannot import Scripts within a script*/
          }

          {
            /* <!-- Script 5. Google Tag Manager --> <!-- Copy as is.--> */
          }
          ;(function (w, d, s, l, i) {
            w[l] = w[l] || []
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : ''
            j.async = true
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
            f.parentNode.insertBefore(j, f)
          })(window, document, 'script', 'dataLayer', 'GTM-P7T2ZKT')
        }}
      />
    )
  },
)

export { AirCanadaHeaders }
